import Vue from 'vue'

const bus = new Vue()

export function openUserProfile() {
  bus.$emit('user-profile-open')
}

export function openUserFaq() {
  bus.$emit('user-faq-open')
}

export function openUserFeedback() {
  bus.$emit('user-feedback-open')
}

export function openUserAbout() {
  bus.$emit('user-about-open')
}

export function openUserMessages() {
  bus.$emit('user-messages-open')
}

export function emitMessageUnreadChanged() {
  bus.$emit('message-unread-changed')
}

export function onMessageUnreadChanged(handler) {
  bus.$on('message-unread-changed', handler)
}

export function offMessageUnreadChanged(handler) {
  bus.$off('message-unread-changed', handler)
}

export function onUserProfileOpen(handler) {
  bus.$on('user-profile-open', handler)
}

export function offUserProfileOpen(handler) {
  bus.$off('user-profile-open', handler)
}

export function onUserFaqOpen(handler) {
  bus.$on('user-faq-open', handler)
}

export function offUserFaqOpen(handler) {
  bus.$off('user-faq-open', handler)
}

export function onUserFeedbackOpen(handler) {
  bus.$on('user-feedback-open', handler)
}

export function offUserFeedbackOpen(handler) {
  bus.$off('user-feedback-open', handler)
}

export function onUserAboutOpen(handler) {
  bus.$on('user-about-open', handler)
}

export function offUserAboutOpen(handler) {
  bus.$off('user-about-open', handler)
}

export function onUserMessagesOpen(handler) {
  bus.$on('user-messages-open', handler)
}

export function offUserMessagesOpen(handler) {
  bus.$off('user-messages-open', handler)
}

export function emitProfileUpdated() {
  bus.$emit('user-profile-updated')
}

export function onProfileUpdated(handler) {
  bus.$on('user-profile-updated', handler)
}

export function offProfileUpdated(handler) {
  bus.$off('user-profile-updated', handler)
}
